import { useAiChat } from '@factorialco/f0-react'
import type { FormCanvasContent } from '@factorialco/f0-react'

import { defineCanvasEntity } from 'modules/ai/copilotActions/canvas/defineCanvasEntity'

import { FormCanvasContent as LocalFormContent } from 'modules/ai/copilotActions/canvas/forms/components/FormCanvasContent'
import { FormHeader } from 'modules/ai/copilotActions/canvas/forms/components/FormHeader'

/**
 * Inline component used by `renderContent`. Lives as a named component
 * (uppercase) so `useAiChat()` is called inside a real component — the
 * arrow function passed to `renderContent` does not satisfy the
 * react-hooks/rules-of-hooks linter.
 */
const FormCanvasRenderer = () => {
  const { agent, closeCanvas } = useAiChat()
  return <LocalFormContent agent={agent ?? 'one-workflow'} onSubmitComplete={closeCanvas} />
}

/**
 * Canvas renderer for `{ type: "form" }` content. The active form is read
 * from f0's `F0AiFormRegistry`. The renderer derives the co-agent name
 * and close callback from `useAiChat()` and forwards them as props — the
 * underlying components stay decoupled from the chat shell.
 */
export const formCanvasEntity = defineCanvasEntity<FormCanvasContent>({
  type: 'form',
  overflowHidden: true,
  renderContent: () => <FormCanvasRenderer />,
  renderHeader: ({ content, onClose }) => (
    <FormHeader
      title={content.title}
      description={content.description}
      module={content.formModule}
      onClose={onClose}
    />
  ),
})
